import { LineBlockProps } from './type';

interface Props {
  blockProps: LineBlockProps;
  scaleFactor?: number;
  maxWidth: number;
}

export const LineBlock: React.FC<Props> = (props) => {
  const { blockProps, maxWidth, scaleFactor = 1 } = props;
  const { width, fontSize, color, degree = 0 } = blockProps;

  return (
    <div
      style={{
        maxWidth: maxWidth * scaleFactor,
      }}
    >
      <div
        style={{
          borderTop: '1px solid',
          color: color || '',
          minWidth: 8,
          overflow: 'hidden',
          maxWidth: maxWidth * scaleFactor,
          width: `${width * scaleFactor}px`,
          transform: degree !== 0 ? `rotate(${degree}deg)` : 'none',
          transformOrigin: 'center',
          background: 'transparent',
          margin: 2,
          padding: 0,
        }}
      />
    </div>
  );
};
